import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import { absenceTypeParams, typesUrl } from './constants';

export default function prefetchAbsenceTypes(client: APIClient) {
  return prefetchQuery(typesUrl, client, { queryParams: absenceTypeParams });
}
